<template>
    <div
        ref="dropdown"
        :class="[
            'absolute bg-v2-gray-130 border border-v2-gray-110 p-5 right-3 rounded w-64 z-10 at1350:w-80 dark:bg-v2-gray-60 dark:border-v2-gray-10 shadow-black/20 shadow-xl',
              openUpwards ? 'bottom-full mb-2' : 'top-[57.5%] mt-6',
              isFooterButton ? 'shrink-0 -left-32 at1200:-left-24  !bottom-full' : '',
        ]"
    >
        <ul class="space-y-2">
            <EditDetails v-if="tray.name !== 'Favorites'" :tray="tray" />
            <ExportTray :tray="tray" />
            <AddItemsTo :tray="tray" />
            <DeleteTray v-if="tray.name !== 'Favorites' && !isFooterButton" :tray="tray"/>
        </ul>
    </div>
</template>

<script setup>
import EditDetails from "@/Components/Modules/Dialogs/Pins/Components/PinsDialogIndex/TrayDropdown/EditDetails.vue";
import ExportTray from "@/Components/Modules/Dialogs/Pins/Components/PinsDialogIndex/TrayDropdown/ExportTray.vue";
import AddItemsTo from "@/Components/Modules/Dialogs/Pins/Components/PinsDialogIndex/TrayDropdown/AddItemsTo.vue";
import DeleteTray from "@/Components/Modules/Dialogs/Pins/Components/PinsDialogIndex/TrayDropdown/DeleteTray.vue";
import {nextTick, onBeforeUnmount, onMounted, ref} from "vue";

const props = defineProps(['tray', 'isFooterButton']);

const dropdown = ref(null)
const openUpwards = ref(false)
let updateTimer = null;

function updateDirection() {
    if (!dropdown.value) return
    const rect = dropdown.value.getBoundingClientRect()
    // if the bottom of the dropdown would go past the viewport…
    openUpwards.value = (rect.bottom+100) > window.innerHeight;
}

// Throttled version to prevent flickering
function throttledUpdateDirection() {
    if (updateTimer) return;

    updateTimer = setTimeout(() => {
        updateDirection();
        updateTimer = null;
    }, 100);
}

onMounted(() => {
    nextTick(() => {
        updateDirection()
        window.addEventListener('resize', throttledUpdateDirection)
    })
})

onBeforeUnmount(() => {
    if (updateTimer) {
        clearTimeout(updateTimer);
    }
    window.removeEventListener('resize', throttledUpdateDirection)
})
</script>
